import type { ICartCRUDItem, ICartFullEntityResponse, IProductEntityCartFull } from '../models';
import type { ICartFullResponse, ICartFullResponseItem, ICartUpdateDto } from '#shared/api';
import { getCartUpdateDto } from './getCartUpdateDto';
import { CartFullTrackerMapper } from './CartFullTrackerMapper';

export class _CartFullMapper {
  private cartFullTrackerMapper = new CartFullTrackerMapper();

  public getResponseFromApi(response: ICartFullResponse): ICartFullEntityResponse {
    return {
      id: response.id,
      updatedAt: response.updatedAt,
      products: response?.suborders?.[0]?.items?.map((it) => this.getCartProductEntity(it)) ?? [],
      unavailableProducts:
        response.unavailableItems?.map((it) => this.getCartProductEntity(it)) ?? [],
      config: response.config,
      summary: response.summary,
      deliveryPrices: response.deliveryPrices,
      hasRestrictions: !!response.restrictions?.length,
      _trackerPayload: this.cartFullTrackerMapper.mapTrackerPayload(response),
    };
  }

  private getCartProductEntity(productFromApi: ICartFullResponseItem): IProductEntityCartFull {
    return {
      skuId: productFromApi.goodId,
      title: productFromApi.title,
      id: productFromApi.productId,
      nearestDelivery: productFromApi.nearestDelivery,
      isSelected: productFromApi.selected,
      // новые ручки отдают другую модельку, исправим после перехода на IProductEntity
      // @ts-ignore
      shop: { ...productFromApi.shopInfo },
      photo: {
        link: {
          high: productFromApi.image.prefixUrl + productFromApi.image.postfixUrl,
          low: productFromApi.image.prefixUrl + productFromApi.image.postfixUrl,
        },
      },
      fullPrice: productFromApi.totalBasePrice,
      sellPrice: productFromApi.totalFinalPrice,

      badges: productFromApi.badges.map((it) => ({
        id: it.id,
        text: it.title,
        textColor: it.textColor,
        backgroundColor: it.backgroundColor,
      })),

      amount: productFromApi.qnty,
      availableAmount: productFromApi.maxQnty,

      // @ts-ignore
      characteristics: productFromApi.characteristics,

      isFavorite: productFromApi.isFavorite,
    };
  }

  public getCartUpdateDTO(items: ICartCRUDItem[]): ICartUpdateDto {
    return getCartUpdateDto(items);
  }
}

export const CartFullMapper = new _CartFullMapper();
